import { NpvrEventItem } from '@smart-tv/typings/npvr';

import { kmm } from './kmm';
import { mapNpvrEvent } from './npvr-helpers';

export async function getExpiringSoonNpvrEvents(): Promise<NpvrEventItem[]> {
  const events = await kmm((repo) => repo.getExpiringSoonNpvrEvents());

  return events.asJsReadonlyArrayView().map(mapNpvrEvent);
}

export default getExpiringSoonNpvrEvents;
